export const UPDATE_SINGLE_LESSON_REDIRECTS = 'single-lesson/UPDATE_SINGLE_LESSON_REDIRECTS'

export const updateSingleLessonRedirection = (url: string) => ({
  type: UPDATE_SINGLE_LESSON_REDIRECTS,
  url,
})
